import { NameDto } from '@/api/Common/Types'

export interface SwapFreeOptionDto {
  id: string
  countryId: string
  tickmillCompanies: NameDto[]
  green: number
  red: number
  daysTillSuspended: number
  enabled: boolean
}

export enum SwapFreeOptionDtoFilterKey {
  countryId = 'CountryId',
  green = 'Green',
  red = 'Red',
  daysTillSuspended = 'DaysTillSuspended',
  enabled = 'Enabled',
}
